import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Label } from '../../components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';

const FIELDS = [
  { key: 'shop_total', label: 'Shop Total Sales' },
  { key: 'cash', label: 'Cash tender' },
];
const gbp = (v) => `£${(parseFloat(v) || 0).toFixed(2)}`;

export const KeyTotals = ({ totals, defaults, value, onChange }) => (
  <Card data-testid="key-totals-card">
    <CardHeader className="pb-2">
      <CardTitle className="text-base">Key Totals</CardTitle>
      <p className="text-xs text-muted-foreground">Choose which line on the report fills these totals.</p>
    </CardHeader>
    <CardContent className="grid sm:grid-cols-2 gap-4">
      {FIELDS.map(f => {
        const options = totals?.[f.key] || [];
        const current = value?.[f.key] || defaults?.[f.key] || '';
        return (
          <div key={f.key} className="space-y-1">
            <Label>{f.label}</Label>
            <Select value={current} onValueChange={(v) => onChange(f.key, v)} disabled={!options.length}>
              <SelectTrigger data-testid={`key-total-${f.key}`}>
                <SelectValue placeholder="Upload a report first" />
              </SelectTrigger>
              <SelectContent>
                {options.map(o => (
                  <SelectItem key={o.value} value={o.value}>
                    {o.label} - {gbp(o.amount)}{o.value === defaults?.[f.key] ? ' (default)' : ''}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
        );
      })}
    </CardContent>
  </Card>
);
